import toastr from 'toastr';
import 'url-search-params-polyfill';

toastr.options = {
    positionClass: 'toast-bottom-left',
};

$(function () {
    // Utility functions
    const showToast = (message, type = 'success') => {
        toastr[type](message);
    };

    const updateElementClass = (element, className, add = true) => {
        element[add ? 'addClass' : 'removeClass'](className);
    };

    const ajaxRequest = (method, url, data, successCallback, errorCallback) => {
        $.ajax({
            type: method,
            url,
            data,
            dataType: 'json',
            success: (response) => {
                successCallback(response);
            },
            error: (error) => {
                showToast('Er is een fout opgetreden. Probeer het later opnieuw.', 'error');
                if (errorCallback) errorCallback(error);
            },
        });
    };

    // Favorite functionality
    const toggleFavorite = (element, single) => {
        const ajaxUrl = element.data('ajax') || element.attr('action');
        const productId = element.data('product_id') || element.find('input[name="product_id"]').val();

        ajaxRequest('POST', ajaxUrl, {
            action: 'kaasfavorieten',
            product_id: productId,
        }, (response) => handleFavoriteResponse(response, element, single));
    };

    const handleFavoriteResponse = (response, element, single) => {
        const isFavorite = response.message === 'fas fa-heart';

        if (single) {
            $('#kaasfavorieten_text').text(isFavorite ? 'Verwijder van favorieten' : 'Voeg toe aan favorieten');
            $('#kaasfavorieten_icon').removeClass().addClass(response.message);
        } else {
            element.find('#kaasfavorieten_icon').removeClass().addClass(response.message);
            updateElementClass(element, 'favorite-button--active', isFavorite); // eslint-disable-line
        }

        showToast(isFavorite ? 'Product toegevoegd als favoriet' : 'Product verwijderd als favoriet');
    };

    $(document).on('click', '.favorite-button', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Stopt verdere afhandeling door andere listeners
        toggleFavorite($(this), false);
    });

    $('#kaasfavorieten').on('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Stopt verdere afhandeling door andere listeners
        toggleFavorite($(this), true);
    });
});